import {
  FullEntityResponse,
  GetEntitiesResponse,
} from 'app/modules/entities/responses';
import { ReactElement } from 'react';
import { ConsortiumHitsTabLabel } from 'app/modules/consortium/components/ConsortiumHitsTabLabel';

export const DEFAULT_GET_ENTITIES_RESPONSE: GetEntitiesResponse = {
  count: null,
  entities: [],
};

export type EntityDetailsTabType = {
  key: string;
  hidden: boolean;
  label: ReactElement | string;
};

export const ENTITY_DETAILS_DEFAULT_TABS: Record<string, EntityDetailsTabType> =
  {
    transactions: {
      key: 'transactions',
      hidden: false,
      label: 'Transactions',
    },

    'action-events': {
      key: 'action-events',
      hidden: false,
      label: 'Action Events',
    },

    risk: {
      key: 'risk',
      hidden: false,
      label: 'Risk',
    },

    documents: {
      key: 'documents',
      hidden: false,
      label: 'Documents',
    },

    instruments: {
      key: 'instruments',
      hidden: false,
      label: 'Instruments',
    },

    'rule-whitelist': {
      key: 'rule-whitelist',
      hidden: false,
      label: 'Rule Silencing',
    },

    'network-analysis': {
      key: 'network-analysis',
      hidden: false,
      label: 'Network Analysis',
    },

    'link-analysis': {
      key: 'link-analysis',
      hidden: false,
      label: 'Link Analysis',
    },

    relationships: {
      key: 'relationships',
      hidden: false,
      label: 'Relationships',
    },

    'geo-location': {
      key: 'geo-location',
      hidden: false,
      label: 'Geolocation',
    },

    'consortium-hits': {
      key: 'consortium-hits',
      hidden: false,
      label: <ConsortiumHitsTabLabel />,
    },
  } as const;

export const INITIAL_ENTITY: FullEntityResponse = {
  id: -1,
  risk_score: 0,
  name_readable: '',
  status: '',
  internal_entity_type: '',
  created_at: '',
  external_id: '',
  entity_type: 'USER',
  type: '',
  tags: [],
  comments: [],
  whitelists: {
    id: -1,
    external_id: '',
    active_whitelists: 0,
  },
  internal_status: '',
  formatted_data: {},
};
